import { BENEFITS_KEY_OVERRIDES } from 'helpers/benefits-key-overrides'
import { convertKeysToPascalCase } from 'helpers/convertKeysToPascalCase'

export function remapClientBenefits(raw) {
  const cb = raw?.clientBenefits

  if (!cb) {
    return { ClientBenefits: { Enrollments: [] } }
  }

  return {
    ClientBenefits: convertKeysToPascalCase(cb, BENEFITS_KEY_OVERRIDES),
  }
}

export function remapBenefit(raw) {
  return convertKeysToPascalCase(raw, BENEFITS_KEY_OVERRIDES)
}
